import { render, staticRenderFns } from "./DropdownItemStatus.vue?vue&type=template&id=51d66c3a&"
import script from "./DropdownItemStatus.vue?vue&type=script&lang=js&"
export * from "./DropdownItemStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports